import { useQuery } from '@tanstack/react-query'

import { axios, ExtractFnReturnType, QueryConfig } from '@apps-common/lib'
import { IMyMonitoringAccountUnitItemModel } from '@apps-common/types/portal/my-monitoring'

export const QUERY_KEY_GET_MY_MONITORING_ACCOUNT_UNITS = (id?: number) => ['getMyMonitoringAccountUnits', id].filter(Boolean)

export const getMyMonitoringAccountUnits = async (id: number): Promise<IMyMonitoringAccountUnitItemModel[]> =>
  axios.get(`/MyMonitoringAccountManagement/GetAccountUnits?id=${id}`).then((res) => res.data?.data)

type QueryFnType = typeof getMyMonitoringAccountUnits

type Props = {
  config?: QueryConfig<QueryFnType>
  id: number
}

export const useGetMyMonitoringAccountUnits = ({ config, id }: Props) =>
  useQuery<ExtractFnReturnType<QueryFnType>>({
    ...{ ...config, cacheTime: 0 },
    queryKey: QUERY_KEY_GET_MY_MONITORING_ACCOUNT_UNITS(id),
    queryFn: () => getMyMonitoringAccountUnits(id)
  })
